import { render, staticRenderFns } from "./RecommendationGroups.vue?vue&type=template&id=2adb9aa4&scoped=true&"
import script from "./RecommendationGroups.vue?vue&type=script&lang=js&"
export * from "./RecommendationGroups.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationGroups.vue?vue&type=style&index=0&id=2adb9aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adb9aa4",
  null
  
)

export default component.exports